import { z } from "zod";

import {
  DataExportV2TriggerType,
  DataExportV2TriggerSubType,
} from "@north-beam/nb-client-side/nb-api-graphql-generated";

import { scheduleTimeFrameSchema } from "./time-frame-schema";

const baseScheduleTriggerSchema = z.object({
  type: z.literal(DataExportV2TriggerType.SCHEDULED),
  scheduleName: z.string(),
});

export const scheduleTimeBasedTriggerSchema = baseScheduleTriggerSchema.extend({
  subType: z.literal(DataExportV2TriggerSubType.TIME_BASED),
  timeFrames: z.array(scheduleTimeFrameSchema),
});

export const scheduleTriggerSchema = z.discriminatedUnion("subType", [
  scheduleTimeBasedTriggerSchema,
]);
